import { Status } from "../../../../analytics-types/lib/esm/status.js";
var buildResult = function(event, code, message) {
  if (code === void 0) {
    code = 0;
  }
  if (message === void 0) {
    message = Status.Unknown;
  }
  return { event, code, message };
};
export {
  buildResult
};
//# sourceMappingURL=result-builder.js.map
